
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/square",
      function () {
        return require("private-next-pages/square/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/square"])
      });
    }
  